import React from 'react';

import { getPredictivePartner } from '@Pages/RetroSynthesis/predictiveUtils';
import { ProjectSynthesisPartner } from '../../constants';

import './TooltipContentConfidence.scss';

function TooltipContentConfidence() {
  const partner = getPredictivePartner();
  return (
    <div className="rs-tooltip-big__content info-tooltip-content tooltip-content-confidence">
      {partner === ProjectSynthesisPartner.PAI && (
        <>
          <div>
            <b>Confidence score</b> represents the mathematical probability score generated by neural networks to rank the routes for a
            given molecule taking into account:
          </div>
          <ul className="info-tooltip-content-list">
            <li className="info-tooltip-content-list-item bullet-dot">
              a probability distribution over all possible chemical transformations to select disconnection for progressing the
              retrosynthesis,
            </li>
            <li className="info-tooltip-content-list-item bullet-dot">
              probability score of each step in the forward direction to select the correct starting materials (to filter out improbable
              reactions), and
            </li>
            <li className="info-tooltip-content-list-item bullet-dot">the number of reaction steps.</li>
          </ul>
        </>
      )}
      {partner === ProjectSynthesisPartner.IKTOS && (
        <>
          <div>
            The scores presented in this column are the Iktos Retro-Score (RScore), which computes a synthetic accessibility score of
            molecules by performing a full retrosynthetic analysis. The lowest RScore value is 0, indicating no route was found within a
            given period of time; and the highest score is 1, where the route is a one-step retrosynthesis exactly matching a reaction
            described in the literature.
          </div>
          <div>The RScore is calculated considering several parameters, incl.</div>
          <ul className="info-tooltip-content-list">
            <li className="info-tooltip-content-list-item bullet-dot">number of reaction steps,</li>
            <li className="info-tooltip-content-list-item bullet-dot">
              likelihood of the disconnections of the retrosynthesis route predicted by a single step retrosynthesis model
            </li>
            <li className="info-tooltip-content-list-item bullet-dot">
              applicability domain estimation of the reaction templates used to make the disconnections
            </li>
            <li className="info-tooltip-content-list-item bullet-dot">similarity to reactions published in the literature</li>
            <li className="info-tooltip-content-list-item bullet-dot">
              convergence of the route (if starting materials of a given reaction in a route are smaller than the product, then a higher
              score is calculated)
            </li>
          </ul>
          <div>
            A high RScore corresponds to a route which is short, has no regioselectivity issues, with good expansion network probability,
            close to literature, and which breaks the input molecule into smaller parts.
          </div>
        </>
      )}
    </div>
  );
}

export default TooltipContentConfidence;
